var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrid = function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#grid_svg__a)",
    fill: "#D2AB67",
    stroke: "#D2AB67",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.465,
    y: 1.5,
    width: 5.859,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.465,
    y: 10.5,
    width: 5.859,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.253,
    y: 1.5,
    width: 5.859,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.253,
    y: 10.5,
    width: 5.859,
    height: 6,
    rx: 1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "grid_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h17.576v18H0z"
  })))));
};
export default SvgGrid;